<div class="flex min-h-screen flex-col text-slate-50">
  <app-header-toolbar
    class="w-full"
    [isAuthenticated]="isAuthenticated()"
    [version]="version()"
    [versionDate]="versionDate()"
    [envLabel]="envLabel()"
    (logout)="onLogout()"
  />
  <app-breadcrumb class="w-full"></app-breadcrumb>

  <main class="flex flex-1">
    <router-outlet />
  </main>
</div>

